export default __webpack_public_path__ + "static/media/tw.8ea0b61c.svg";